const Profile = () => {
    return (
        <div>
            <h1>Profile</h1>
            <p>This is the profile page.</p>
        </div>
    );
}
export default Profile;